// components/feature/demand/InformationPopovers.tsx
import React from 'react'
import { Divider, makeStyles, mergeClasses, tokens, Link } from '@fluentui/react-components'
import { DemandAnalysisQuestion } from '../../../../api/schemas/schema'
import { t } from '../../../../i18n/i18n'
import {
   Info20Regular,
   Info20Filled,
   Lightbulb20Regular,
   Lightbulb20Filled,
   ClipboardLink20Regular,
   ClipboardLink20Filled,
   Open20Regular,
} from '@fluentui/react-icons'
import { QuestionPopover } from './QuestionPopover'
import { Text } from '../../../common/text/Text'
import { QuestionInfoPopover } from './QuestionInfoPopover'

const useStyles = makeStyles({
   wrapper: {
      display: 'flex',
      paddingBottom: tokens.spacingVerticalL,
   },
})

type InformationPopoversProps = {
   item: DemandAnalysisQuestion
   className: string
   includeQuestion?: boolean
}

export const InformationPopovers = ({ item, className, includeQuestion }: InformationPopoversProps) => {
   const classes = useStyles()

   return (
      <>
         <div className={mergeClasses(classes.wrapper, className)}>
            {includeQuestion && <QuestionPopover item={item} />}

            <QuestionInfoPopover
               item={item}
               btnLabel={t('BackgroundInformation')}
               popoverLabel={t('BackgroundInformationForTheQuestion')}
               regularIcon={<Info20Regular />}
               filledIcon={<Info20Filled />}
               pickText={(d) => d.backgroundInformation}
            />

            <QuestionInfoPopover
               item={item}
               btnLabel={t('OriginDemand')}
               popoverLabel={t('OriginDemandForTheQuestion')}
               regularIcon={<ClipboardLink20Regular />}
               filledIcon={<ClipboardLink20Filled />}
               pickText={(d) => d.demandText}
               renderLink={(d) => {
                  if (d.demandUrl) {
                     return (
                        <Text size={300}>
                           {t('ReadMore')}:{' '}
                           <Link href={d.demandUrl} target="_blank" appearance="default">
                              {d.demandUrlText} <Open20Regular />
                           </Link>
                        </Text>
                     )
                  }
                  if (d.demandSource) {
                     return (
                        <span>
                           <Text block={false} weight="semibold">
                              {t('Source')}:
                           </Text>{' '}
                           <Text block={false}>{d.demandSource}</Text>
                        </span>
                     )
                  }
                  return null
               }}
            />

            <QuestionInfoPopover
               item={item}
               btnLabel={t('TipFrom365Robust')}
               popoverLabel={t('TipFrom365Robust')}
               regularIcon={<Lightbulb20Regular />}
               filledIcon={<Lightbulb20Filled />}
               pickText={(d) => d.proposedActionTip}
            />
         </div>
         <Divider appearance="brand" />
      </>
   )
}
